import { icon } from "../icons.js";
import { esc, richText } from "./html.js";
import { nightsWord, roomsWord } from "../lib/dates.js";
import { fmtRub } from "../lib/money.js";
import { cardsFromLengths, prepaymentLabel } from "../lib/avail.js";
import { guestsSummary } from "./searchbar.js";

// Ширина фото в карусели (T41) — по ней браузер выбирает копию 800/1200/1600 из srcset.
// Карточки: телефон — экран, планшет — две колонки, шире — колонка сетки (≤ ~480px).
// Итог оформления: до 900px растянут на всю ширину (styles.css), шире — колонка 340px.
export const SHOT_SIZES = {
  cards: "(max-width: 700px) 100vw, (max-width: 1100px) 50vw, 480px",
  summary: "(max-width: 900px) 100vw, 340px",
};

// экспорт — карусель переиспользует карточка-итог оформления (T6)
export function carousel(card, sizes = SHOT_SIZES.cards) {
  const area = card.area ? `<span class="okb-areatag">${card.area} м²</span>` : "";
  if (!card.photos.length) {
    return `<div class="okb-carousel">${area}<div class="okb-nophoto">Фото скоро появятся</div></div>`;
  }
  // свои копии 800/1200 px (T41): браузер берёт по ширине карточки и плотности экрана
  const shots = card.photos
    .map(
      (p, i) =>
        `<img src="${esc(p.url || p.urlLarge)}"${p.srcset ? ` srcset="${esc(p.srcset)}" sizes="${sizes}"` : ""} alt="${esc(card.name)} — фото ${i + 1}" loading="lazy" decoding="async">`,
    )
    .join("");
  const many = card.photos.length > 1;
  const dots = many
    ? `<div class="okb-dots">${card.photos.map((_, i) => `<i${i === 0 ? ' class="okb-on"' : ""}></i>`).join("")}</div>`
    : "";
  // стрелки (T9.5e): листают ленту скроллом (index.js, shot-prev/shot-next), точки обновляет scroll
  const nav = many
    ? `<button type="button" class="okb-shotnav okb-shotprev" data-okb="shot-prev" aria-label="Предыдущее фото">${icon("chevron")}</button>
       <button type="button" class="okb-shotnav okb-shotnext" data-okb="shot-next" aria-label="Следующее фото">${icon("chevron")}</button>`
    : "";
  return `<div class="okb-carousel">${area}<div class="okb-shots" data-okb-shots>${shots}</div>${nav}${dots}</div>`;
}

function card(c, L) {
  // «Домик семейный + (корпус №5)» → название + подстрока
  const m = c.name.match(/^(.*?)\s*\((.+)\)\s*$/);
  const title = esc(m ? m[1] : c.name);
  const sub = m ? `<small>${esc(m[2])}</small>` : "";
  const low = c.rooms <= 3;
  const pct = prepaymentLabel(c.total, c.prepaymentRub);
  const tariff = c.tariff
    ? `
    <div class="okb-tariff">
      <div class="okb-tarhead">
        <span><span class="okb-tarlabel">Тариф</span><span class="okb-tarname">${esc(c.tariff.name)}</span></span>
        ${c.discountPercent ? `<span class="okb-disc">−${c.discountPercent}%</span>` : ""}
        ${c.tariff.isPromotion ? `<span class="okb-chip okb-promo-chip">Акция</span>` : ""}
      </div>
      ${
        c.tariff.description
          ? `<details class="okb-acc" style="margin-top:8px"><summary>В стоимость включено ${icon("chevronDown")}</summary><div class="okb-accbody">${richText(c.tariff.description)}</div></details>`
          : ""
      }
    </div>`
    : "";
  return `
  <article class="okb-card">
    ${carousel(c)}
    <div class="okb-cardbody">
      <div class="okb-cardhead"><span class="okb-name">${title}${sub}</span></div>
      <div class="okb-meta">
        ${c.beds ? `<span class="okb-chip">до ${c.beds} гостей</span>` : ""}
        ${low ? `<span class="okb-stock">Осталось ${c.rooms} ${roomsWord(c.rooms)}</span>` : ""}
      </div>
      ${
        c.description
          ? `<details class="okb-acc"><summary>Описание номера ${icon("chevronDown")}</summary><div class="okb-accbody">${richText(c.description)}</div></details>`
          : ""
      }
      ${tariff}
      <div class="okb-pricegrid">
        <div>
          <label>Стоимость</label>
          <div class="okb-total">${fmtRub(c.total)}</div>
          ${c.oldTotal ? `<div class="okb-old">${fmtRub(c.oldTotal)}</div>` : ""}
          <div class="okb-pernight">${fmtRub(Math.round(c.total / L))} за ночь</div>
        </div>
        ${
          c.prepaymentRub != null
            ? `<div>
          <label>К оплате сейчас</label>
          <div class="okb-prepay">${fmtRub(c.prepaymentRub)}</div>
          ${pct ? `<span class="okb-prepaypct">${pct}</span>` : ""}
        </div>`
            : ""
        }
      </div>
      <button type="button" class="okb-bookbtn" data-okb="book" data-cat="${c.catId}">Забронировать</button>
    </div>
  </article>`;
}

// «Доступные номера (N)» — по снимку поиска (ref_5)
export function renderResults(state) {
  const s = state.search;
  if (!s) return "";
  const cards = cardsFromLengths(s.lengthsData, state.map?.cats, s.L, s.adults);
  if (!cards.length) {
    return `
    <div class="okb-reshead"><h2>Доступные номера</h2><span class="okb-count">(0)</span></div>
    <div class="okb-hintcard">${icon("warn")}<div><h3>На эти даты ничего не нашлось</h3>
    <p>${s.refusal ? `Бронирование недоступно: ${esc(s.refusal)}.` : `Для ${guestsSummary({ adults: s.adults, children: s.children })} на ${s.L} ${nightsWord(s.L)} свободных номеров нет.`} Попробуйте другие даты или измените состав гостей.</p></div></div>`;
  }
  return `
  <div class="okb-reshead"><h2>Доступные номера</h2><span class="okb-count">(${cards.length})</span></div>
  <div class="okb-cards">${cards.map((c) => card(c, s.L)).join("")}</div>`;
}
